import { LatLng, insideCircle } from "geolocation-utils";

export class Circle {
  private _radius: number;
  private _center: LatLng;

  constructor(center: LatLng, radius: number) {
    this._radius = radius;
    this._center = center;
  }

  // Getters

  public get center() {
    return this._center;
  }

  // Public Methods

  getRadiusIn(unit: "m" | "km") {
    return unit === "m" ? this._radius : this._radius / 1000;
  }

  isInside(coordinate: LatLng) {
    return insideCircle(coordinate, this.center, this.getRadiusIn("m"));
  }
}
